export class Status {
  public loading: boolean;
  public error: boolean;
  public success: boolean;
  public progress: number;

  constructor(
    loading: boolean = false,
    error: boolean = false,
    success: boolean = false,
    progress: number = 0
  ) {
    this.loading = loading;
    this.error = error;
    this.success = success;
    this.progress = progress;
  }

  private reset() {
    this.loading = false;
    this.error = false;
    this.success = false;
    this.progress = 0;
  }

  public setError() {
    this.reset();
    this.error = true;
  }

  public setSuccess() {
    this.reset();
    this.success = true;
    setTimeout(() => this.reset(), 2000);
  }

}
